import { createSlice } from '@reduxjs/toolkit'
import { saveLocalStorage } from '../../../core/utils'
import { requests } from '../../../core/ajax'
import { loaderActions } from '../../loader/slices'
import { formatPermissions } from '../utils'
import { feedback } from '../../../core/feedback'
import { resetAppsData } from '../../applications/slices'
import { resetUserData } from '../../profile/slices'

const initialState = {
  isAuthorized: false,
  userId: '',
  role: '',
  accessToken: '',
  permissions: {},
}

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setAuthorization: (state, { payload }) => {
      state.isAuthorized = payload
    },
    setAuthData: (state, { payload }) => {
      state.userId = payload.user_id
      state.role = payload.role
      state.accessToken = payload.token
      state.permissions = payload.permissions
    },
    resetAuthData: () => initialState,
  },
})

export const globalReducer = globalSlice.reducer
export const { setAuthorization, setAuthData, resetAuthData } = globalSlice.actions

export const loginUser = (userState, userDispatch) => (dispatch) => {
  const localData = { 'apg-auth': userState }
  saveLocalStorage('dsc', localData)
  let permissions = {}
  if (userState.permissions) {
    permissions = formatPermissions(userState.permissions)
  }

  dispatch(setAuthData({ ...userState, permissions }))
  dispatch(setAuthorization(true))
  if (userDispatch) {
    userDispatch({ type: 'LOGIN', payload: userState })
  }
}

export const logoutUser = (userDispatch) => async (dispatch) => {
  try {
    await requests.revokeToken()
    feedback('success', 'Sesión cerrada correctamente')
  } catch (err) {
    const msg = err?.response?.data?.message || 'Error al cerrar sesión'
    feedback('error', msg)
  } finally {
    saveLocalStorage('dsc', { 'apg-auth': {} })

    dispatch(resetAuthData())

    dispatch(loaderActions.reset())
    dispatch(resetUserData())
    dispatch(resetAppsData())
    if (userDispatch) {
      userDispatch({ type: 'LOGOUT' })
    }
  }
}
